import { Box, type BoxProps } from '@mantine/core'
import React, { useEffect } from 'react'

import {
  type CoreProductPhoto,
  type CoreProductPhotoPayload,
} from '@flecto/types'

import { BoxItemPhoto } from './BoxItemPhoto'
import classes from './styles.module.css'
import { usePhotoManagerState } from './usePhotoManagerState'

export type ItemPhotoForManager = CoreProductPhotoPayload &
  Omit<CoreProductPhoto, 'id'> & {
    links: {
      photo_url: string
    }
  }

export type PhotoManagerProps = BoxProps & {
  hasError?: boolean
  onChange?: (photos: CoreProductPhotoPayload) => void
  photoObject: ItemPhotoForManager
  title?: string
}

export function PhotoManager({
  hasError = false,
  onChange,
  photoObject,
  title,
  ...props
}: PhotoManagerProps) {
  const { initializeFromItem, photo, photoAttributes } = usePhotoManagerState()

  useEffect(() => {
    initializeFromItem(photoObject)
  }, [])

  useEffect(() => {
    onChange?.(photoAttributes)
  }, [photoAttributes])

  return (
    <Box {...props} className={classes.boxPhoto}>
      <BoxItemPhoto
        data-testid={'box-photo'}
        error={photo === undefined && hasError}
        photo={photo}
        title={title}
      />
    </Box>
  )
}
